var _defs, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleSpinner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 536 536",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:92px;}.cls-1{stroke:#123dc6;}.cls-2{stroke:url(#Degradado_sin_nombre_2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_2",
    x1: 86.85,
    y1: 331.55,
    x2: 215.3,
    y2: -21.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#123dc6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1242c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#1050c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0e68c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0b89bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#07b4b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#02e8b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ffaf"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Loading spinner 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 268,
    cy: 268,
    r: 221.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268,46.75C145.81,46.75,46.75,145.81,46.75,268"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleSpinner);
export default __webpack_public_path__ + "static/media/circle-spinner.596d9ac831600899ad5fdfd5fa6207f1.svg";
export { ForwardRef as ReactComponent };